import { createActionGroup, props } from '@ngrx/store';
import { FEATURE_NAME } from './l7-config-dialog.constant';

export const l7ConfigDialogActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'open': props<{ projectId: string }>()
  }
});

